import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isAddress } from 'utils'
import axios from 'axios'
import { API_POOL_BASE_URL } from 'constants/links'

export const REFERRAL_PARAM = 'addy'
const REFERRAL_EXPIRATION_MS = 5 * 60 * 1000

export default function AddyHandler() {
  const location = useLocation()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const referral = urlParams.get(REFERRAL_PARAM)

    const usedReferral = referral
    const usedExpirationTime = REFERRAL_EXPIRATION_MS

    const storedReferral = localStorage.getItem(REFERRAL_PARAM)
    const storedTimestamp = localStorage.getItem(`${REFERRAL_PARAM}_timestamp`)
    const storedReferralExpirationMs = localStorage.getItem(`${REFERRAL_PARAM}_expiration_ms`)

    if (storedReferral && storedTimestamp && storedReferralExpirationMs) {
      const elapsedTime = Date.now() - parseInt(storedTimestamp, 10)
      if (elapsedTime > parseInt(storedReferralExpirationMs)) {
        localStorage.removeItem(REFERRAL_PARAM)
        localStorage.removeItem(`${REFERRAL_PARAM}_timestamp`)
        localStorage.removeItem(`${REFERRAL_PARAM}_expiration_ms`)
      }
    }

    const storeReferral = (address: string) => {
      localStorage.setItem(REFERRAL_PARAM, address)
      localStorage.setItem(`${REFERRAL_PARAM}_timestamp`, Date.now().toString())
      localStorage.setItem(`${REFERRAL_PARAM}_expiration_ms`, `${usedExpirationTime ?? REFERRAL_EXPIRATION_MS}`)
    }

    if (usedReferral) {
      if (isAddress(usedReferral)) {
        storeReferral(usedReferral)
      } else {
        axios
          .get(`${API_POOL_BASE_URL}/api/get-id`, {
            params: { address: usedReferral },
          })
          .then((response) => {
            const evmAddress = response.data?.address
            if (evmAddress && isAddress(evmAddress)) {
              storeReferral(evmAddress)
            }
          })
          .catch((error: any) => {
            console.error('Error fetching EVM address:', error)
          })
      }
    }
  }, [location.search])

  return null
}
